import { CommonModule } from '@angular/common'
import { Component, ElementRef, inject, Input, OnDestroy, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { AppDescriptionWidget } from 'htv-lib'
import { PageService } from '../../services/page.service'
import { LocalApp } from '../../interfaces/local-app'
import { Subscription } from 'rxjs'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-app-description',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './app-description.component.html',
  styleUrls: [],
})
export class AppDescriptionComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()

  protected el = inject(ElementRef)
  @Input() config!: AppDescriptionWidget

  text = ''

  constructor(private pageService: PageService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_APP)?.subscribe((app: LocalApp) => {
        if (app) {
          this.text = '' // TODO: Retrieve app description from somewhere
        } else {
          this.text = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
